import profileIcon from "#/assets/exam-results/profile.svg?url";
import type {
  TExamQuestionsForResultSet,
  TPersonInfo,
} from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set.types";
import { postMediaRequest } from "#/services/rest/gwt/exam-results/media-request/media-request.api";
import { errorToastOption } from "@monta/components";
import { Button, Toast, Tooltip } from "@monta/design-system";
import { env } from "@monta/env";
import { Done, DoneLight, Video, VideoDark } from "@monta/icons";
import clsx from "clsx";
import { useMemo, useState } from "react";
import styles from "./answer.module.scss";

type Props = {
  answerAuthorInfo?: TExamQuestionsForResultSet["answerAuthorInfo"];
  mediaHasRequested?: TExamQuestionsForResultSet["mediaHasRequested"];
  mediaRequestCount?: TExamQuestionsForResultSet["mediaRequestCount"];
  mediaId?: TExamQuestionsForResultSet["mediaId"];
  mediaLink?: TExamQuestionsForResultSet["mediaLink"];
  id: TExamQuestionsForResultSet["id"];
};

const AskVideo = (props: Props) => {
  const {
    answerAuthorInfo,
    mediaHasRequested,
    mediaRequestCount,
    mediaId,
    mediaLink,
    id,
  } = props;

  const [hover, setHover] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(mediaHasRequested);
  const [submissionCount, setSubmissionCount] = useState(mediaRequestCount);

  const authors: { personInfoList: TPersonInfo[] } =
    answerAuthorInfo && JSON.parse(answerAuthorInfo || "");

  const answerAuthor = authors?.personInfoList ?? [];

  const names = useMemo(() => {
    return (authors?.personInfoList ?? [])?.map((item) => item.name).join(" ");
  }, [authors]);

  const { mutate: mediaRequestMutate, isLoading } =
    postMediaRequest.useMutation({
      onSuccess: (result) => {
        if (result.resultCode > 0) {
          Toast.success({
            message: "درخواست شما با موفقیت ثبت شد",
          });

          setHasSubmitted(true);
          setSubmissionCount((mediaRequestCount || 0) + 1);
        } else Toast.error(errorToastOption);
      },
      onError: () => {
        Toast.error(errorToastOption);
      },
    });

  const openMedia = (mediaLink: string) => {
    window.open(mediaLink);
  };

  return (
    <div className={styles["ask-video"]}>
      <div className={styles["ask-video__title"]}>
        {answerAuthor.length > 1 ? (
          <Tooltip text={names || ""}>{answerAuthor.length + " مرجع "}</Tooltip>
        ) : (
          <>
            <img
              src={
                answerAuthor[0]?.imageId
                  ? `${env.GWT_URL}/render?id=${answerAuthor[0]?.imageId}`
                  : profileIcon
              }
            />

            <span>{answerAuthor[0]?.name}</span>
          </>
        )}
      </div>

      <Button
        loading={isLoading}
        className={clsx(
          styles["ask-video__video"],
          !hasSubmitted && styles["ask-video__video__pointer"],
        )}
        onClick={() => {
          if (mediaId && mediaLink) openMedia(mediaLink);
          else if (!hasSubmitted)
            mediaRequestMutate({
              body: { questionId: Number(id), hasRequest: true },
            });
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div>
          {mediaId
            ? "مشاهده پاسخ  ویدیویی"
            : hasSubmitted
              ? " درخواست ویدیو ثبت شد "
              : " درخواست ویدیو "}
          {submissionCount ? `( ${submissionCount} )` : ""}
        </div>

        {hasSubmitted && !mediaId ? (
          hover ? (
            <DoneLight size={16} />
          ) : (
            <Done size={16} />
          )
        ) : hover ? (
          <Video size={16} />
        ) : (
          <VideoDark size={16} />
        )}
      </Button>
    </div>
  );
};
export default AskVideo;
